export default __webpack_public_path__ + "static/media/active-user-guide-icon.71c31555.svg";